






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { dateFormate } from '@/utils/report';
const Report = namespace('report');

@Component
export default class MonthlyDate extends Vue {
  @Prop() private reportId!: number;
  @Prop() private level!: number;
  @Prop() private store_group_id!: number;

  @Report.Mutation('update_export_success') private UPDATE_EXPORT_SUCCESS: any;
  @Report.Getter('exportSuccess') private exportSuccess!: boolean;

  private dialogExportVisible: boolean = false;
  private loading: boolean = false;
  private start: Date | string = new Date();
  private end: Date | string = new Date();
  get startPickerOptions() {
    return {
      disabledDate: (time: Date) => {
        let curDate = (new Date()).getTime();
        let three = 12 * 30 * 24 * 3600 * 1000;
        let _12Months = curDate - three;
        let endDate = new Date(this.end).getTime();
        return time.getTime() >= endDate || time.getTime() <= _12Months;
      }
    }
  };
  get endPickerOptions() {
    return {
      disabledDate: (time: Date) => {
        let curDate = (new Date()).getTime();
        let startDate = new Date(this.start).getTime();
        return time.getTime() >= curDate || time.getTime() <= startDate;
      }
    }
  };
  public mounted() {
    const level = this.$route.query.level;
    const start = sessionStorage.getItem("start"); 
    const end = sessionStorage.getItem("end"); 
    if (start && end && level === '1') {
      this.start = start;
      this.end = end;
      this.$emit('datePass', start, end);
    }
  }
  public recovery() {
    this.$emit('recovery');
  }
  public exportReport() {
    this.dialogExportVisible = true;
    this.UPDATE_EXPORT_SUCCESS(false);
    this.$emit('exportReport');
  }
  public datePickerChange() {
    sessionStorage.setItem("start", dateFormate(this.start));
    sessionStorage.setItem("end", dateFormate(this.end));
    this.$emit('datePass', dateFormate(this.start), dateFormate(this.end));
    this.$emit('fetchReport');
  }
}
